import * as React from 'react'
import styled from 'styled-components'

import { Section } from '@espoon-voltti/react-components/layout'
import { Title } from '@espoon-voltti/react-components/elements'

import { LabelValueList } from '@espoon-voltti/react-voltti/components/label-value-list'

import { NuoraOrg } from '@espoon-voltti/nuora-domain/applicants'

import { t } from '../../../i18n'

const Spacer = styled.div`
  margin-top: 40px;
`

interface Props {
  nuoraOrg: NuoraOrg
}

export const NuoraOrgInfo: React.FC<Props> = (p) => (
  <Section dataQa="nuoraOrg">
    <Title dataQa="additionalInfoTitle" size={3}>
      {t(['org', 'additionalInfo', 'title'])}
    </Title>
    <LabelValueList
      dataQa={'n/a'}
      values={[
        {
          dataQa: 'activity',
          label: t(['org', 'additionalInfo', 'activity', 'label']),
          value: t([
            'org',
            'additionalInfo',
            'activity',
            'values',
            p.nuoraOrg.activity
          ])
        },
        {
          dataQa: 'targetGroup',
          label: t(['org', 'additionalInfo', 'targetGroup', 'label']),
          value: t([
            'org',
            'additionalInfo',
            'targetGroup',
            'values',
            p.nuoraOrg.targetGroup
          ])
        }
      ]}
    />

    <Spacer />

    <Title dataQa="membersTitle" size={3}>
      {t(['org', 'additionalInfo', 'members', 'info', 'label'])}
    </Title>
    <LabelValueList
      dataQa={'members'}
      values={[
        {
          dataQa: 'from7to20',
          label: t(['org', 'additionalInfo', 'members', 'from7to20', 'label']),
          value: p.nuoraOrg.members.from7to20
        },
        {
          dataQa: 'from21to28',
          label: t(['org', 'additionalInfo', 'members', 'from21to28', 'label']),
          value: p.nuoraOrg.members.from21to28
        },
        {
          dataQa: 'from29',
          label: t(['org', 'additionalInfo', 'members', 'from29', 'label']),
          value: p.nuoraOrg.members.from29
        }
      ]}
    />
  </Section>
)
